import script from "./AudienceCompositionStage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceCompositionStage.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceCompositionStage.vue?vue&type=style&index=0&id=d051c3de&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d051c3de"]])

export default __exports__